<mat-tab-group
  [color]="color"
  [backgroundColor]="backgroundColor"
  (selectedIndexChange)="updateOutput({ index: $event })"
>
  @for (tab of _tabs; track tab) {
    <mat-tab
      [labelClass]="$any(tab.labelStyleClasses | parse: context | async)"
    >
      <ng-template mat-tab-label>
        @if (isExpression(tab.label) || isString(tab.label)) {
          {{ tab.label | parse: context | async }}
        } @else {
          <ng-container [dynamicWidget]="tab.label" [context]="context" />
        }
      </ng-template>
      <ng-container [dynamicWidget]="tab.widget" [context]="context" />
    </mat-tab>
  }
</mat-tab-group>
